import { useEffect, useState } from 'react'
import { WeaverLoading } from 'Components'
import withDetailsContainer from './withDetailsContainer'
import { getAttributeKeyLabel, getProjectData, getMemberKey, splitUid } from 'Services/WeaverUtils'
import { Tooltip } from 'antd'
import { relationAttributesRenderer } from './shared'

export default NodeDetails = ({ data }) ->
  [item, setItem] = useState(undefined)
  [loading, setLoading] = useState(true)

  useEffect( ->
    ( ->
      setLoading(true)
      [id, graph] = splitUid(data.id)
      q = new Weaver.Query()
        .restrict([id])
        .inGraph(graph)
        .selectOut('*')
        .selectIn('*')
        .withRelations()

      (getProjectData().relationAttributes or [])
        .map(({ relKey }) ->
          q.selectOut(relKey, getMemberKey())
        )

      node = await q.first()

      setItem(node)
      setLoading(false)
    )()
    undefined
  , [data])

  return <WeaverLoading style={{ margin: '33%' }} /> if loading
  Details = withDetailsContainer(item, { nodeIsEditable: true })

  <Details>
    {
      _.chain(item.attributes())
      .map((val, key) ->
        {
          key,
          label: <Tooltip title={key}>{ _.truncate(getAttributeKeyLabel(key), { length: 25 }) }</Tooltip>
          value: val
        }
      ).sortBy('key')
      .value()
      .concat(relationAttributesRenderer(item))
    }
  </Details>
